import React, {useCallback} from "react";
import {useNavigate} from "react-router-dom";

export const useChangeClient = (subPage: string) => {
    const navigate = useNavigate();

    const handleClientChange = useCallback(
        (clientID: string | undefined) => {
            if(!clientID) return
            navigate(`?clientID=${clientID}&subPage=${subPage}`);
        },
        [navigate, subPage]
    );

    return {handleClientChange};
};